import { useAppSelector } from '../useAppSelector';
import { useLookups } from '../useLookups';
import * as lookupSlice from '../../data/lookup.slice';

export const useClientAddressUse = (
  addressUseBC: string | undefined,
): string => {
  useLookups(['clientAddressUse']);
  const addressUses = useAppSelector(lookupSlice.selectClientAddressUses);
  const addressUse = addressUses.find(
    (s) => s.clientAddressUseBC === addressUseBC,
  );
  return addressUse ? addressUse.clientAddressUseName : '';
};
